import React, { useCallback } from 'react';

import { useTransition, animated } from 'react-spring';
import type { ModalProps } from 'react-native-modal';

import { SlideIn, FadeIn } from './animations';
import { Content } from '../styles';
import { Backdrop } from './backdrop';

const AnimatedContent = animated(Content);

/**
 * Renders a modal component (for Web).
 *
 * @param modalProps - Render props for modal display.
 */
export function Modal(modalProps: ModalProps) {
  const { isVisible, onBackdropPress, children, animationIn } = modalProps;
  const animation = (animationIn && animationIn === 'slideInUp') ? SlideIn : FadeIn;
  const popup = useTransition(isVisible, null, animation);

  const handleOnBackdropPress = useCallback(
    (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      stopPropagation(event);

      if (onBackdropPress) {
        onBackdropPress();
      }
    },
    [onBackdropPress]
  );

  return (
    <Backdrop show={isVisible} onPress={handleOnBackdropPress}>
      {popup.map(
        ({ item, key, props }) =>
          item && (
            <AnimatedContent key={key} style={props} onClick={stopPropagation}>
              {children}
            </AnimatedContent>
          )
      )}
    </Backdrop>
  );
}
/**
 * Prevents element from propagating its `onClick` event.
 *
 * @param event - Event properties.
 */
function stopPropagation(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
  event.stopPropagation();
}
